export default class HeaderMobile {
  constructor(el) {
    this.el = el;
    this.expandBtn = null;
    this.closeBtn = null;
    this.navOpen = false;
    this.subNavs = null;
    this.subOpen = false;
    this.navigationMobile = null;
    this.observer = null;
    this.init();
    this.initEvents();
  }

  init() {
    this.expandBtn = this.el.querySelector(".expand");
    this.closeBtn = this.el.querySelector(".close");
    this.subNavs = this.el.querySelectorAll(".has--sub");
    this.navigationMobile = document.querySelector(".c-navigation--mobile");
    let section;
    if (this.navigationMobile != null) {
      section = section = document.querySelector(
        ".c-navigation--mobile"
      ).parentElement;

      this.observer = new IntersectionObserver(
        ([e]) => {
          let scrollheight = document.querySelector("html").scrollTop;
          if (
            e.intersectionRatio === 1 &&
            !e.target.classList.contains("isSticky")
            && scrollheight > 0
          ) {
            e.target.classList.toggle("isSticky");
          }
          if (
            e.intersectionRatio < 1 &&
            e.target.classList.contains("isSticky") &&
            e.intersectionRect.y < 100
            && scrollheight > 0
          ) {
            e.target.classList.toggle("isSticky");
          }
          if (e.target.classList.contains("isSticky")) {
            document.querySelector("html").scrollTop = scrollheight;
          }
        },
        { threshold: [1], rootMargin: "-1px 0px 0px 0px", root: section }
        //rootmargin values checken
      );
    }
  }

  initEvents() {
    this.expandBtn.removeEventListener("click", (e) => this.openNav(e));
    this.expandBtn.addEventListener("click", (e) => this.openNav(e));

    this.closeBtn.removeEventListener("click", (e) => this.openNav(e));
    this.closeBtn.addEventListener("click", (e) => this.openNav(e));

    this.subNavs.forEach((sub) => {
      sub.removeEventListener("click", (e) => this.openSub(e));
      sub.addEventListener("click", (e) => this.openSub(e));
    });
    if (this.observer != null && this.navigationMobile != null) {
      this.observer.observe(this.navigationMobile);
    }
  }

  openNav(e) {
    this.navOpen = !this.navOpen;
    e.preventDefault();

    let nav = this.el.querySelector(".c-mobile-navigation");
    if (this.navOpen) {
      nav.style.display = "flex";
      this.getSiblings(this.el.parentNode).forEach((sibling) => {
        sibling.style.display = "none";
      });
    } else {
      nav.style.display = "none";
      this.getSiblings(this.el.parentNode).forEach((sibling) => {
        sibling.style.removeProperty("display");
      });
    }
  }

  openSub(e) {
    if (e.target.localName === "a" && e.target.getAttribute("target")) return;

    e.preventDefault();

    /**
     * open sub navs
     */
    let subnav = null;
    if (e.target.localName == "a") {
      subnav = e.target.parentNode.querySelector(
        ".c-mobile-navigation--sub-nav"
      );
    } else {
      subnav = e.target.querySelector(".c-mobile-navigation--sub-nav");
    }

    /**
     * close sub navs
     */
    
    if (e.target.localName == "a") {
      if (e.target.classList.contains("close-btn")) {
        subnav = e.target.parentNode;
        this.openNav(e);
      }
      if (e.target.classList.contains("back-btn")) {
        subnav = e.target.parentNode;
      }
    }
    if (e.target.localName == "i") {
      if (e.target.classList.contains("fa-xmark")) {
        subnav = e.target.parentNode.parentNode;
        this.openNav(e);
      }
      if (e.target.classList.contains("fa-arrow-left")) {
        subnav = e.target.parentNode.parentNode;
      }
    }
    if (subnav != null) {
      if (!this.subOpen) {
        subnav.style.display = "block";
        this.subOpen = true;
        this.el.querySelector(".c-mobile-navigation").lastElementChild.style.zIndex =
          "-1";
      } else {
        subnav.style.display = "none";
        this.subOpen = false;
        this.el.querySelector(".c-mobile-navigation").lastElementChild.style.zIndex =
          "0";
      }
    }

    /**
     * follow link
     */
    if (
      e.target.classList.contains("nav-item") ||
      e.target.classList.contains("nav-item--focus")
    ) {
      window.location = e.target.firstChild.getAttribute("href");
    }
    if (
      e.target.parentNode.classList.contains("nav-item") ||
      e.target.parentNode.classList.contains("nav-item--focus")
    ) {
      window.location = e.target.getAttribute("href");
    }
  }

  getSiblings(elem) {
    return Array.from(elem.parentNode.children).filter(function (sibling) {
      return sibling !== elem;
    });
  }
}
